module.exports = __webpack_public_path__ + "img/no-data.80a440f8.png";